import type { SheetData } from "x-data-spreadsheet";

/**
 * How the data-editor sheet is read into a tables DataView (PowerPoint). The visual's settings are the source of
 * truth; the visual copies the relevant fields here so the editor's own parse (on every cell change, on linked-data
 * refresh) applies the same choices as a re-parse from the Data fields pane.
 */
export interface TablesParseOptions {
    /** Header of the text column dropped on Group; the rows are pivoted by its values */
    groupByColumn?: string;
    /** "Columns (n)" in Group: every measure column in use becomes a group of its own; excludes `groupByColumn` */
    columnsAsGroups?: boolean;
    /** Header of the text column dropped on Comments (text columns are Comments by header or by this choice) */
    commentColumn?: string;
    /** Measure columns unticked in the Data fields pane, by header */
    excludedColumns?: string[];
    /** The Category levels by header, in order, once the user changed them; unset = the leading text columns */
    categoryColumns?: string[];
    /** Text columns the user dropped on a value bucket; read as text measures instead of being left out */
    textMeasureColumns?: string[];
}

let options: TablesParseOptions = {};

/**
 * The flat sheet of the last parse, in memory. Office storage is written through a queue with a delay, so right
 * after a chooser insert the stored sheet isn't readable yet; the Excel write-back and a re-parse use this first.
 */
let lastParsedSheet: SheetData | null = null;

export function setLastParsedSheet(sheet: SheetData) {
    lastParsedSheet = sheet;
}

export function getLastParsedSheet(): SheetData | null {
    return lastParsedSheet;
}

export function setTablesParseOptions(next: TablesParseOptions) {
    options = { ...next };
}

export function getTablesParseOptions(): TablesParseOptions {
    return options;
}
